import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface PdfExportFlags {
  Zones: boolean;
  UserParameters: boolean;
  CuringGraph: boolean;
  Graph3D: boolean;
  TemperatureOverTime: boolean;
  Notes: boolean;
  Log: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class ExportApiService {
  constructor(private http: HttpClient) {}

  generateCSV(
    projectName: string,
    tenantId: string,
    unitCode: number
  ): Observable<Blob> {
    const params = new HttpParams()
      .set('projectName', projectName)
      .set('tenantId', tenantId)
      .set('unitCode', unitCode.toString())
      .set('code', environment.apiKey);

    return this.http.get(`${environment.apiUrl}GetReportCSV`, {
      params,
      responseType: 'blob',
    });
  }

  generatePDF(
    projectName: string,
    tenantId: string,
    unitCode: number,
    flags: PdfExportFlags,
    chartImages: Record<string, string> = {}
  ): Observable<Blob> {
    const params = new HttpParams()
      .set('projectName', projectName)
      .set('tenantId', tenantId)
      .set('unitCode', unitCode.toString())
      .set('code', environment.apiKey);

    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const body = { Flags: flags, ChartImages: chartImages };

    return this.http.post(`${environment.apiUrl}GetReportPDF`, body, {
      params,
      headers,
      responseType: 'blob',
    });
  }

  downloadBlob(blob: Blob, filename: string): void {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.click();
    window.URL.revokeObjectURL(url);
  }
}
